import {
  ADD_CAR_BRAND_FAIL,
  ADD_CAR_BRAND_REQUEST,
  ADD_CAR_BRAND_SUCCESS,
  ADD_CUSTOMER_FAIL,
  ADD_CUSTOMER_REQUEST,
  ADD_CUSTOMER_SUCCESS,
  DELETE_CAR_BRAND_FAIL,
  DELETE_CAR_BRAND_REQUEST,
  DELETE_CAR_BRAND_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  GET_CAR_BRAND_LIST_FAIL,
  GET_CAR_BRAND_LIST_REQUEST,
  GET_CAR_BRAND_LIST_SUCCESS,
  GET_CUSTOMER_LIST,
  GET_CUSTOMER_LIST_FAIL,
  GET_CUSTOMER_LIST_SUCCESS,
  GET_SINGLE_CAR_BRAND_FAIL,
  GET_SINGLE_CAR_BRAND_REQUEST,
  GET_SINGLE_CAR_BRAND_SUCCESS,
  GET_SINGLE_CUSTOMER,
  GET_SINGLE_CUSTOMER_FAIL,
  GET_SINGLE_CUSTOMER_SUCCESS,
  UPDATE_CAR_BRAND_FAIL,
  UPDATE_CAR_BRAND_REQUEST,
  UPDATE_CAR_BRAND_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
} from "src/constants/types";

export const carBrandReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CAR_BRAND_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CAR_BRAND_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        carBrands: actions.payload,
        error: "",
      };
    case GET_CAR_BRAND_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CAR_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CAR_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CAR_BRAND_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CAR_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CAR_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CAR_BRAND_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CAR_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CAR_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        carBrand: actions.payload,
      };
    case GET_SINGLE_CAR_BRAND_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CAR_BRAND_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CAR_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CAR_BRAND_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
